module.exports = __webpack_public_path__ + "static/freeapp-probate-2374d45ced2a39e17ab09b449a29f70b.png";